import React, { useState, useEffect } from "react";
import VesselOperator from "../../components/VesselOperator";
import "./TripForm2.scss";
import TripType from "../../components/TripType";
import NrCrew from "../../components/NrCrew";
import NrAnglers from "../../components/NrAnglers";
import { getTripType } from "../../constants/vtrTrip";

export default function TripForm2(props) {
  const [tripType, setTripType] = useState("");

  useEffect(() => {
    if (props.types) {
      setTripType(String(getTripType(props.currentType, props.types)));
    }
  }, [props.types, props.currentType]);

  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <div className="trip-form-container" id={"trip_form_2"}>
      <TripType
        currentType={props.currentType}
        types={props.types}
        handleChange={props.handleChange}
        preferences={props.preferences.trip}
        handleTripTypePreferenceChange={props.handleTripTypePreferenceChange}
        helpText={props.helpText}
      />
      {props.showNrCrewField && (
        <NrCrew
          handleInputChange={props.handleInputChange}
          number_of_crew={props.number_of_crew}
          preferences={props.preferences.trip}
          trip_type={tripType}
          handleTripPreferenceChange={props.handleTripPreferenceChange}
          helpText={props.helpText}
        />
      )}
      {props.showNrAnglersField && (
        <NrAnglers
          handleInputChange={props.handleInputChange}
          number_of_anglers={props.number_of_anglers}
          preferences={props.preferences.trip}
          trip_type={tripType}
          handleTripPreferenceChange={props.handleTripPreferenceChange}
          helpText={props.helpText}
        />
      )}
      <VesselOperator
        changeHandler={props.handleOperatorChange}
        operatorOptions={props.operator_options}
        operator_permit_number={props.operator_permit_number}
        operator_first_name={props.operator_first_name}
        operator_middle_name={props.operator_middle_name}
        operator_last_name={props.operator_last_name}
        operator_ext_name={props.operator_ext_name}
        handleTripOperatorPreferenceChange={props.handleTripOperatorPreferenceChange}
        preferences={props.preferences.operator}
        helpText={props.helpText}
      />
    </div>
  );
}
